/* eslint-disable no-unused-vars */
import DataTable from '@/containers/data_table_ml/DataTable';
import styles from './TablePage.less?modules';
import ButtonML from '@/components/button_ml/ButtonML';
import Popconfirm from '@/containers/popconfirm/Popconfirm';
// import { CONSTANT } from '../../constant/index';

const TablePage = (props) => {
  const { loadingstatus, edit, pushLog, pushDecisionGraphMap } = props || {};
  const handleMemberDelete = (record) => {
    props.deleteItem(record);
  };

  // const goToModal = (recor) => {
  //   console.log(recor);
  // };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 100,
    },
    {
      title: '输入参数',
      dataIndex: 'inputItem',
      key: 'inputItem',
      width: 60,
    },
    {
      title: '操作人员',
      dataIndex: 'operator',
      key: 'operator',
      width: 50,
    },
    {
      title: '操作类型',
      dataIndex: 'operationType',
      key: 'operationType',
      width: 100,
    },
    {
      title: '操作前',
      dataIndex: 'operationBefore',
      key: 'operationBefore',
      width: 60,
    },
    {
      title: '操作后',
      dataIndex: 'operationAfter',
      key: 'operationAfter',
      width: 60,
    },
    {
      title: '操作时间',
      dataIndex: 'operationTime',
      key: 'operationTime',
      width: 120,
    },
  ];
  return (
    <>
      <DataTable
        className="demo-test"
        style={{ minWidth: '1547px' }}
        columns={columns}
        rowSelection={false}
        // pagination={pagination}
        scroll={{ y: 'calc(100vh - 156px - 3rem)' }}
        loading={loadingstatus}
        dataSource={props.tableData}
        changePage={(a) => {
          props.pageNumChange(a);
        }}
        changePageSize={(a) => {
          props.pageSizeChange(a);
        }}
      />
    </>
  );
};
export default TablePage;
